const STORAGE_KEY = 'kiku:last-dept-slug';

export function useActiveDepartment(): [string | null, (slug: string) => void] {
  const lastDeptSlug = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;

  function setActiveDepartment(slug: string): void {
    localStorage.setItem(STORAGE_KEY, slug);
  }

  return [lastDeptSlug, setActiveDepartment];
}
